import { render, staticRenderFns } from "./DifferentiatingBenefitsComunitSection.vue?vue&type=template&id=bc98c994"
import script from "./DifferentiatingBenefitsComunitSection.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefitsComunitSection.vue?vue&type=script&lang=ts"
import style0 from "./DifferentiatingBenefitsComunitSection.vue?vue&type=style&index=0&id=bc98c994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports